import React, { useEffect, useRef } from 'react';

const MOBILE_AD = {
  unit: 'DAN-A4GHaFlGIWY72V0u',
  width: '320',
  height: '50'
};

const DESKTOP_AD = {
  unit: 'DAN-XIL26L6cVjLfIFa6',
  width: '160',
  height: '600'
};

const KakaoAdBanner = ({ className, placement = 'mobile', style }) => {
  const adRef = useRef(null);
  const scriptLoadedRef = useRef(false);
  const adInitialized = useRef(false);
  const ad = placement === 'desktop' ? DESKTOP_AD : MOBILE_AD;

  useEffect(() => {
    adInitialized.current = false;
    if (!adRef.current) return undefined;

    const showFallbackContent = () => {
      if (adRef.current) {
        adRef.current.innerHTML = `
          <div style="
            background: linear-gradient(45deg, #f8f9fa, #e9ecef);
            border: 1px dashed #6c757d;
            border-radius: 8px;
            padding: 15px;
            text-align: center;
            color: #6c757d;
            font-size: 12px;
          ">
            <i class="fas fa-ad" style="margin-right: 5px;"></i>
            광고 영역 (개발 환경)
          </div>
        `;
        adRef.current.style.display = 'block';
      }
    };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//t1.kakaocdn.net/kas/static/ba.min.js';
    script.async = true;
    script.dataset.adfitUnit = ad.unit;
    script.onload = () => {
      scriptLoadedRef.current = true;
      adInitialized.current = true;
      console.log('카카오 AdFit 스크립트 로드 완료');
    };
    script.onerror = () => {
      console.warn('카카오 애드핏 스크립트 로드 실패');
      showFallbackContent();
    };

    // AdFit 스크립트는 실행 시점의 kakao_ad_area를 스캔하므로
    // 광고 슬롯이 DOM에 붙은 다음 스크립트를 삽입한다.
    const frame = window.requestAnimationFrame(() => {
      adRef.current?.insertAdjacentElement('afterend', script);
    });

    // localhost 환경 감지 및 대체 콘텐츠 표시
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1';
    let timer;

    if (isLocalhost) {
      timer = setTimeout(() => {
        if (adRef.current && !adInitialized.current) {
          showFallbackContent();
        }
      }, 2000);
    }

    return () => {
      window.cancelAnimationFrame(frame);
      if (timer) clearTimeout(timer);
      script.remove();
    };
  }, [ad.unit]);

  return (
    <div
      className={`kakao-ad-container kakao-ad-container--${placement} ${className || ''}`}
      style={style}
    >
      <ins 
        key={ad.unit}
        ref={adRef}
        className="kakao_ad_area" 
        data-ad-unit={ad.unit}
        data-ad-width={ad.width}
        data-ad-height={ad.height}
      />
    </div>
  );
};

export default KakaoAdBanner;
